import Button from "components/Elements/Button/Button";
import Icon from "components/Elements/Icon/Icon";
import ThanksActionModals from "./components/ThanksActionModals";
import { memo, useEffect, useState } from "react";
import { useContent } from "contexts/contentContext/contentContext";
import { useModal } from "contexts/modalContext/modalContext";
import { useUser } from "contexts/userContext/userContext";
import { useLocation, useParams } from "react-router-dom";

import styles from "./thanksActionButton.module.scss";
import "./thanksActionButton.scss";
import useMailSender from "hooks/useMailSender";

const URL_PAYMENT_SUCCESS_PARAM = "payment-success";

const ThanksActionButton = memo(() => {
  const { getTextByKey, getDirection, getPath } = useContent();
  const location = useLocation();
  const params = useParams();
  const { setModal } = useModal();
  const { isLoggedIn } = useUser();
  const { isMailSender } = useMailSender();

  const isPaymentSuccess = params?.anotherParam === URL_PAYMENT_SUCCESS_PARAM;

  useEffect(() => {
    if (isPaymentSuccess) {
      setModal({
        modal: ThanksActionModals,
        modalOverlayClass: "test-modal-container",
        props: {
          firstModalId: "thanks-form-modal",
        },
      });

      // remove unsued params from url
      const path = window.location.pathname;
      const parts = path.split("/");
      const pageSegment = parts[3];

      const currentPage =
        pageSegment === "home" ? pageSegment : `${pageSegment}/${parts?.[4]}`;

      window.history.pushState(
        null,
        "",
        `${window.location.origin}/l${getPath()}${currentPage}`
      );
    }
  }, [isPaymentSuccess, location.pathname]);

  const gallaryPage = window.location.pathname.includes("gallery");
  const [isAnon, setIsAnon] = useState(false);

  useEffect(() => {
    setIsAnon(gallaryPage && !isLoggedIn());
  }, [gallaryPage, isLoggedIn]);

  const handleOpen = () => {
    setModal({
      modal: ThanksActionModals,
      modalOverlayClass: "test-modal-container",
      props: {
        firstModalId: "amount-for-thanks",
      },
    });
  };

  const direction = getDirection();
  const isRTL = direction === "rtl";
  const positionClass = isRTL ? styles.wrapperRtlPos : styles.wrapperPos;

  const galleryPositionClass = gallaryPage
    ? isRTL
      ? styles.galleryPageBtnRtlPos
      : styles.galleryPageBtnPos
    : "";

  const sizeClass = isAnon || !isMailSender() ? styles.galleryPageBtnSize : "";

  return (
    <>
      <Button
        id="thankYouButton"
        className={`${styles.wrapper} ${positionClass} ${galleryPositionClass} ${sizeClass}`}
        onClick={handleOpen}
      >
        <Icon name="heart" white large iconClass="heart-icon-desc" />
        <Icon name="heart-color" large iconClass="heart-icon-mob" />
        <p>{getTextByKey("send-thanks")}</p>
      </Button>
    </>
  );
});

export default ThanksActionButton;
